import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffectOnce } from "@lib-shared/hooks";
import { BusinessPage, ButtonText } from "core/constants";
import { logApiError } from "core/lib";
import { ModalAlert } from "core/lib/show-modal";
import PaymentService, { PaymentStatusResponseDetail } from "core/services/cef/payment.service";
import PaymentsStore from "core/stores/payments.store";
import MahPaymentResult from "./components/mah-payment-result";
import PleaseWait from "components/please-wait";
import Button from "components/ui/form/button";

const PaymentResult = () => {
    const navigate = useNavigate();
    const goBackToDashboard = (event: any) => navigate(BusinessPage.dashboard);
    const [response, setResponse] = useState<PaymentStatusResponseDetail | undefined>(undefined);
    const [hasError, setHasError] = useState<boolean>(false);

    const statusUpdateInterval = 2000; //2 secs

    useEffectOnce(() => {
        const onLoad = async () => {
            const transactionId = PaymentsStore.transactionId.value;
            const statusResponse = await new PaymentService().paymentStatus(transactionId)

            try {
                const statusResult = statusResponse.data.paymentStatusResponse.paymentStatusResponseDetail;

                setResponse(statusResult);

                if (statusResult.status.toLowerCase() === "pending") {
                    setTimeout(() => onLoad(), statusUpdateInterval);
                }
            } catch (error) {
                logApiError(error);

                setHasError(true);

                ModalAlert.error("There has been an error getting the status of this payment", "", {
                    showClose: false
                });
            }
        }

        onLoad();
    });

    if (hasError) {
        return null;
    }

    if (!response) {
        return <PleaseWait message="Getting your payment status" />;
    }

    return (
        <section className="payment-result">
            <MahPaymentResult response={response} />

            <p className="please-note">
                <strong>Please Note:</strong><br />
                Payments may take a few moments to reflect.
            </p>

            <Button onClick={goBackToDashboard} text={ButtonText.goBackToDashboard} className="dashboard" />
        </section>
    );
}

export default PaymentResult;
